import React from 'react'

/**
 * A quick guide to markdown so admin users can understand what the possibilities for announcement formatting/markup.
 * 
 * Adapted from https://gist.github.com/apackeer/4159268
 * 
 * @author Arden Packeer 
 * @author Alex Clary
 */
const MarkDownExample = () =>
  <div className='usa-accordion'>
    <button className='usa-accordion-button' aria-expanded='false' aria-controls='markdown-quick-example'>
      A quick markdown example
      </button>
    <div id='markdown-quick-example' className='usa-accordion-content'>
      <code>
        # H1<br />
        ## H2<br />
        ### H3<br />
        #### H4<br />
        ##### H5<br />
        ###### H6<br />
        * Unordered<br />
        * List<br />
        1. Ordered<br />
        2. List<br />
        <br />
        Emphasis, aka italics, with *asterisks* or _underscores_.<br />
        <br />
        Strong emphasis, aka bold, with **asterisks** or __underscores__.<br />
        <br />
        Combined emphasis with **asterisks and _underscores_**.<br />
        <br />
        Strikethrough uses two tildes. ~~Scratch this.~~<br />
        ![alt text](https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 1")<br />
        <br />
        [I'm an inline-style link](https://www.google.com)<br />
        <br />
        | Tables        | Are           | Cool  |<br />
        | ------------- |:-------------:| -----:|<br />
        | col 3 is      | data          | $1600 |<br />
        | col 2 is      | centered      |   $12 |<br />
      </code>
    </div>
  </div>

export default MarkDownExample